import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../sprites/logo.png';
import { useBubbleTransition } from './BubbleTransition';

function Navbar({ isRegisterPage }) {
  const trigger  = useBubbleTransition();
  const navigate = useNavigate();

  // Scroll to a section on the main page (same page – no route change)
  const scrollTo = (id) => {
    trigger(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    });
  };

  // Navigate to a different route using React Router (keeps the app mounted!)
  const goTo = (path) => {
    trigger(() => navigate(path));
  };

  if (isRegisterPage) {
    return (
      <nav>
        <div className="nav-brand">
          <span
            style={{ cursor: 'none', display: 'flex', alignItems: 'center' }}
            onClick={() => goTo('/')}
          >
            <img src={logo} alt="Code It Up 6.0" className="nav-logo" />
          </span>
        </div>
        <ul>
          <li>
            <button onClick={() => goTo('/')}>Home</button>
          </li>
        </ul>
      </nav>
    );
  }

  return (
    <nav>
      <div className="nav-brand">
        <img src={logo} alt="Code It Up 6.0" className="nav-logo" />
      </div>
      <ul>
        <li><button onClick={() => scrollTo('home')}>Home</button></li>
        <li><button onClick={() => scrollTo('about')}>About</button></li>
        <li><button onClick={() => scrollTo('team')}>Team</button></li>
        <li><button onClick={() => scrollTo('ambassadors')}>Ambassadors</button></li>
        <li><button onClick={() => scrollTo('sponsors')}>Sponsors</button></li>
        <li><button onClick={() => scrollTo('editions')}>Past Editions</button></li>
        <li>
          <button className="nav-register-btn" onClick={() => goTo('/register')}>
            Register Now
          </button>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;